
import React from 'react';
import { useState, useContext } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { GlobalStateContext } from "../../context/GlobalStateContext";
import GetLevantaProductsData from "../../hooks/get-levanta-products";
import sugestedProductsService from "../../services/sugested-products";

const Banner = ({titleText, setSearchTitle}) => {
    const {pathname} = useLocation();
    const navigate = useNavigate();
    const [ searchValue, setSearchValue ] = useState('');
    const { setSearchResults, setSugestedProducts, setProductsList, setLoading } = useContext(GlobalStateContext);
    
    const submitSearch = async (e) => {
        e.preventDefault(e);

        if(searchValue !== '') {

            setSugestedProducts([]);
            setSearchResults([]);
            setProductsList([]);
            setLoading(true);
            
            try {
                const params = new URLSearchParams({title: searchValue}).toString()
                await GetLevantaProductsData(setLoading, () => {}, () => {}, (searchData) => {
                    if(searchData.length > 0) {
                        setSearchTitle('Search results:')
                        setSearchResults(searchData);
                    } else {
                        setLoading(true);
                        const params = new URLSearchParams({orderBy: 'p.ratings_total', order: 'desc'}).toString()
                        GetLevantaProductsData(setLoading, () => {}, () => {}, (searchData) => {
                            setSearchTitle('We couldn\'t find any products by your request. Here are the most popular products:')
                            setSearchResults(searchData);
                        }, params, null, () => {}, () => {});
                    }
                }, params, null, () => {}, () => {});
            } catch (error) {
                setLoading(false);
            }
        }
    }

    const supportsWebP = (() => {
        const elem = document.createElement('canvas');
        return elem.toDataURL('image/webp').startsWith('data:image/webp');
    })();

    return (
        <div className="axil-main-slider-area main-slider-style-7 main-banner" style={supportsWebP ? {backgroundImage: 'url(/images/banner/banner-bg.webp)'} : {backgroundImage: 'url(/images/banner/banner-bg.png)'}}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="main-slider-content">
                        <h1 className="title">{titleText}</h1>
                        <div className="shop-btn">
                            <a href="#main" className="axil-btn btn-bg-secondary right-icon">SHOP NOW</a>
                        </div>
                        <div className="search-form">
                            <form onSubmit={submitSearch}>
                                <input type="text" value={searchValue} onChange={(e) => setSearchValue(e.target.value)} placeholder="Search for a brand" />
                                <button type="submit"><i className="fas fa-search"></i></button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Banner;